export default __webpack_public_path__ + "static/media/ENG. INFOR.96816592.pdf";